import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      lang: 'he',
      token: null,
      email: null,
      firstName: null,
      lastName: null,
      departmentId: null,
      id: null,
      userAllowCrm: null, // New field for user's allowed CRM
    },
    general: {
      statuses: null
    },
    crm: {
      modeSource: 'hova' // default to hova CRM
    }
  },
  mutations: {
    authUser (state, userData) {
      //console.log('authUser mutation - userData:', userData);
      //console.log('authUser mutation - userAllowCrm:', userData.userAllowCrm);

      state.user.token = userData.token
      state.user.email = userData.email
      state.user.firstName = userData.firstName
      state.user.lastName = userData.lastName
      //state.user.departmentId = userData.userDepartmentId
      state.user.departmentId = userData.departmentId
      state.user.id = userData.id
      state.user.userAllowCrm = userData.userAllowCrm || 'hova' // Default to hova if not provided

     // console.log('authUser mutation - Final state.user.userAllowCrm:', state.user.userAllowCrm);
    },
    general (state, data) {
      for (let i in data) {
        state.general[i] = data[i]
      }
    },
    clearAuthData (state) {
      state.user.token = null
      state.user.email = null
      state.user.firstName = null
      state.user.lastName = null
      state.user.departmentId = null
      state.user.id = null
      state.user.userAllowCrm = null
      state.crm.modeSource = 'hova' // Reset to default
    },
    changeModeSource (state, modeSource) {
      state.crm.modeSource = modeSource
      localStorage.setItem('modeSource', modeSource)
    }
  },
  actions: {

    register ({ commit, dispatch }, authData) {

      commit('authUser', {
        token: authData.data.data.jwt,
        id: authData.data.data.userId
      })

      dispatch('setLogoutTimer', authData.data.data.exp)

      const now = new Date()
      const expDate = new Date(now.getTime() + authData.data.data.exp * 1000)
      localStorage.setItem('token', authData.data.data.jwt)

      // Set initial modeSource
      let initialModeSource;
      if (authData.user && authData.user.userAllowCrm === 'all') {
        initialModeSource = 'hova'; // Default to hova for users who can switch
      } else {
        initialModeSource = 'hova'; // Default for new users
      }
      commit('changeModeSource', initialModeSource);

      // Set initial userAllowCrm
      commit('authUser', {
        token: authData.data.data.jwt,
        id: authData.data.data.userId,
        userAllowCrm: 'hova' // Default for new users
      });
      localStorage.setItem('userAllowCrm', 'hova');

    },

    login ({ commit, dispatch }, authData) {
      commit('authUser', {
        token: authData.token,
        email: authData.user.email,
        firstName: authData.user.firstName,
        lastName: authData.user.lastName,
        departmentId: authData.user.departmentId,
        id: authData.user.id,
        userAllowCrm: authData.user.userAllowCrm || 'hova'
      })
      commit('general', {
        statuses: authData.statuses,
      })

      // Set initial modeSource based on user's allowed CRM
      let initialModeSource;
      if (authData.user.userAllowCrm === 'all') {
        initialModeSource = 'hova'; // Default to hova for users who can switch
      } else {
        initialModeSource = authData.user.userAllowCrm || 'hova';
      }
      commit('changeModeSource', initialModeSource);

      localStorage.setItem('token', authData.token);
      localStorage.setItem('email', authData.user.email);
      localStorage.setItem('firstName', authData.user.firstName);
      localStorage.setItem('lastName', authData.user.lastName);
      localStorage.setItem('departmentId', authData.user.departmentId);
      localStorage.setItem('statuses', JSON.stringify(authData.statuses));
      localStorage.setItem('id', authData.user.id)
      localStorage.setItem('userAllowCrm', authData.user.userAllowCrm || 'hova');
    },

    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('token')
      localStorage.removeItem('modeSource')
      localStorage.removeItem('userAllowCrm')
      router.replace('/login')

      // Refresh the page to reset all state
      window.location.reload();
    },

    changeCrmMode ({ commit }, modeSource) {
      commit('changeModeSource', modeSource)
    },

    tryAutoLogin ({ commit }) {
      const token = localStorage.getItem('token');
      const email = localStorage.getItem('email');
      const firstName = localStorage.getItem('firstName');
      const lastName = localStorage.getItem('lastName');
      const departmentId = localStorage.getItem('departmentId');
      const statuses = localStorage.getItem('statuses');
      const id = localStorage.getItem('id');
      const modeSource = localStorage.getItem('modeSource');
      const userAllowCrm = localStorage.getItem('userAllowCrm');

      if (!token) {
        return false
      }

      commit('authUser', {
        token: token,
        email: email,
        firstName: firstName,
        lastName: lastName,
        departmentId: departmentId,
        id: id,
        userAllowCrm: userAllowCrm || 'hova'
      })

      if (modeSource) {
        commit('changeModeSource', modeSource)
      } else if (userAllowCrm) {
        // Set modeSource based on user's allowed CRM
        let initialModeSource;
        if (userAllowCrm === 'all') {
          initialModeSource = 'hova'; // Default to hova for users who can switch
        } else {
          initialModeSource = userAllowCrm;
        }
        commit('changeModeSource', initialModeSource)
      } else {
        // Set default if not exists
        commit('changeModeSource', 'hova')
      }

      commit('general', {
        statuses: JSON.parse(statuses || '{}'),
      })

      return true
    },
  },
  getters: {
    isAuth (state) {
      return state.user.token != null
    },
    jwt (state) {
      return state.user.token
    },
    userId (state) {
      return state.user.id
    },
    userDepartmentId (state) {
      return state.user.departmentId
    },
    lang (state) {
      return state.user.lang
    },
    fullUsername (state) {
      return state.user.firstName + ' ' + state.user.lastName
    },
    isRTL (state) {
      const rtl = ['he']
      return rtl.includes(state.user.lang)
    },
    getStatuses(state){
      return state.general.statuses
    },
    isAdmin(state){
      return state.user.departmentId == '1'
    },
    isManagement(state){
      return state.user.departmentId == '2'
    },
    isProduction(state){
      return state.user.departmentId == '40'
    },
    isProducerWorker(state){
      return state.user.departmentId == '43'
    },
    isCcShow(state){
     return (['43','40','2','1'].indexOf(state.user.departmentId) !== -1)
    },
    isHostName(state){
      return window.location.hostname
    },
    currentModeSource: state => state.crm.modeSource,
    userAllowCrm: state => state.user.userAllowCrm
  }
})
